<template>
  <div class="avue-ueditor">
    <Toolbar :editor="editor"
             :defaultConfig="editorConfig"
             class="avue-ueditor__toolbar"
             mode="default" />
    <Editor :style="{height: rows*150+'px',overflowY: 'hidden'}"
            v-model="text"
            :defaultConfig="editorConfig"
            mode="default"
            @onFocus="handleFocus"
            @onBlur="handleBlur"
            @onChange="handleChange"
            @onCreated="handleCreated" />
  </div>
</template>
<script>
import { getClient } from './upload/ali'
import { getToken } from './upload/qiniu'
import { getAsVal, validatenull, uuid } from './upload/util'
import { detailImg } from './upload/canvas'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import { shallowRef } from 'vue'
export default {
  name: 'AvueUeditor',
  components: { Editor, Toolbar },
  props: {
    rows: {
      type: [Number, String],
      default: 3
    },
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    headers: {
      type: Object,
      default: () => {
        return {}
      },
    },
    customConfig: {
      type: Object,
      default: () => {
        return {}
      },
    },
    propsHttp: {
      type: Object,
      default: () => {
        return {}
      },
    },
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
    ali: {
      type: Object,
      default: () => {
        return {}
      },
    },
    qiniu: {
      type: Object,
      default: () => {
        return {}
      },
    },
    oss: String,
    action: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      editorConfig: {},
      text: '',
      editor: shallowRef(null),
    }
  },
  computed: {
    fileName () {
      return this.propsHttp.fileName || 'file'
    },
    homeUrl () {
      return this.propsHttp.home || ''
    },
    resKey () {
      return this.propsHttp.res
    },
    imgFlag () {
      return this.img.url == ''
    },
    isImg () {
      return this.img.obj.src
    },
    urlKey () {
      return this.propsHttp.url || 'url'
    },
    isQiniuOSS () {
      return this.oss === 'qiniu'
    },
    isAliOSS () {
      return this.oss === 'ali'
    }
  },
  watch: {
    disabled (val) {
      if (val) {
        this.editor.disable()
      } else {
        this.editor.enable()
      }
    },
    modelValue (val) {
      this.text = val
    }
  },
  created () {
    this.editorConfig = Object.assign(
      { placeholder: this.placeholder },
      this.editorConfig,
      this.customConfig
    )
    this.editorConfig.MENU_CONF = this.editorConfig.MENU_CONF || {}
    this.initUploadImg()
  },
  methods: {
    handleBlur (val) {
      this.$emit('blur', this.text)
    },
    handleFocus (val) {
      this.$emit('focus', this.text)
    },
    handleChange (val) {
      this.$emit('update:modelValue', this.text)
      this.$emit('change', this.text)
    },
    handleCreated (editor) {
      this.editor = editor
      this.text = this.modelValue
      if (this.disabled) {
        this.editor.disable()
      }
    },
    initUploadImg () {
      const callback = {
        customUpload: (file, insert) => {
          this.uploadFile(file).then((res) => {
            insert(res)
          })
        }
      }
      this.editorConfig.MENU_CONF['uploadImage'] = callback
      this.editorConfig.MENU_CONF['uploadVideo'] = callback
    },
    uploadFile (file) {
      return new Promise((resolve, reject) => {
        const done = () => {
          const headers = Object.assign(this.headers, {
            'Content-Type': 'multipart/form-data',
          })
          let oss_config = {}
          let client
          let param = new FormData()
          let url = this.action
          param.append(this.fileName, file)
          Object.keys(this.data).forEach(ele => {
            param.append(ele, this.data[ele])
          })
          if (this.isQiniuOSS) {
            oss_config = this.qiniu
            const token = getToken(oss_config.AK, oss_config.SK, {
              scope: oss_config.scope,
              deadline:
                new Date().getTime() + oss_config.deadline * 3600,
            })
            param.append('token', token)
            url = 'http://up.qiniu.com/'
          } else if (this.isAliOSS) {
            oss_config = this.ali
            client = getClient({
              region: oss_config.region,
              endpoint: oss_config.endpoint,
              accessKeyId: oss_config.accessKeyId,
              accessKeySecret: oss_config.accessKeySecret,
              bucket: oss_config.bucket,
            })
          }
          (() => {
            if (this.isAliOSS) {
              return client.put(file.name, file)
            } else {
              return this.$axios.post(url, param, { headers })
            }
          })().then((res) => {
            let list = {}
            var result = ''
            if (this.isAliOSS) {
              list = res
              result = list.url
            } else if (this.isQiniuOSS) {
              list = res.data
              list.key = oss_config.url + list.key
              result = list.key
            } else {
              if (typeof (this.resKey) === 'function') {
                result = this.resKey(res.data);
              } else {
                list = getAsVal(res.data, this.resKey);
                result = list[this.urlKey]
              }
            }
            var html = this.homeUrl + result
            resolve(html)
          })
            .catch((err) => {
              reject(err)
            })
        }
        if (!validatenull(this.canvasOption)) {
          detailImg(file, this.canvasOption, res => {
            file = res;
            done();
          });
        } else {
          done()
        }
      })
    },
    getUEContent () {
      return this.editor.getHtml()
    }
  }
}
</script>
<style lang="scss">
.avue-ueditor {
  border: 1px solid #ccc;
  &_toolbar {
    border-bottom: 1px solid #ccc;
  }
}
</style>
